import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'profilKurz'
})
export class ProfilKurzPipe implements PipeTransform {


  transform(args?: any): any {
    const words = args.trim().split(/\s+/);
    const vorname = words[0];
    const nachname = words[words.length - 1];
    const vornameInitial = vorname.charAt(0).toUpperCase();
    const nachnameInitial = nachname.charAt(0).toUpperCase();
    return `${vornameInitial}${nachnameInitial}`;
  }
}
